import { cn } from '@cobliteam/ui/utils';
import L from 'leaflet';
import * as styles from './styles';

export const StartIcon = new L.DivIcon({
  html: `<div class="${styles.icon}" />`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export const StartIconComponent = () => {
  return <div className={cn(styles.icon, 'cursor-auto')} />;
};

export default StartIcon;
